import { render, staticRenderFns } from "./MapCenter.vue?vue&type=template&id=8dafa536"
import script from "./MapCenter.vue?vue&type=script&lang=js"
export * from "./MapCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports